// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbItem":"clinics_breadcrumbItem__bKJHB"};